import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";

function FilterModal({
  open,
  onClose,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  statusCode,
  setStatusCode,
  setOrdersApply,
  consumerId,
  setConsumerId,
}) {
  const [matchAll, setMatchAll] = useState(true);

  const handleApply = () => {
    setOrdersApply(true);
    // Implement filter logic or pass values up
    onClose();
  };
  console.log("start", startDate);
  console.log("end", endDate);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
    >
      <DialogTitle>Modify Filters</DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          mt={1}
        >
          <TextField
            type="date"
            label="Start Date"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <TextField
            type="date"
            label="End Date"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <TextField
            label="Status Code"
            value={statusCode}
            onChange={(e) => setStatusCode(e.target.value)}
            sx={{ width: 200 }}
          />
          <TextField
            label="Consumer ID contains"
            value={consumerId}
            onChange={(e) => setConsumerId(e.target.value)}
          />
          {/* <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={matchAll}
                  onChange={() => setMatchAll(!matchAll)}
                />
              }
              label={matchAll ? "Match All Filters" : "Match Any Filter"}
            />
          </FormGroup> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleApply}
          variant="contained"
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FilterModal;
